import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "evrideo-content-control-assets-hub-edit-cell",
  templateUrl: "./content-control-assets-hub-edit-cell.component.html",
  styleUrl: "./content-control-assets-hub-edit-cell.component.scss",
})
export class ContentControlAssetsHubEditCellComponent
  implements ICellRendererAngularComp
{
  params: ICellRendererParams;
  agInit(params: ICellRendererParams): void {
    this.updateParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateParams(params);
    return true;
  }

  updateParams(params: ICellRendererParams) {
    if (!params?.data) {
      return;
    }
    this.params = params;
  }
  goToStudio() {
    window.open(
      `/content-control/studio/${this.params?.data?.mediaId}/edit`,
      "_blank",
    );
  }
}
